import type { LiveDocumentEditingConfig } from '@/document-render/presentation/editing/quote/LiveDocumentEditingConfig';

// `custom` is not quote-editable prose: the host stores no narrative for it, so an edit made on the
// canvas would be dropped silently. It renders read-only until it becomes a field-list kind.
const PROSE_KINDS = new Set(['scope_of_work', 'comments', 'custom_text']);

export function isQuoteEditableKind(kind: string, editing: LiveDocumentEditingConfig | undefined): boolean {
  if (!editing) return false;
  if (kind === 'terms_conditions') return false;
  if (kind === 'price_book' || kind === 'line_items_table') return true;
  if (kind === 'roles_responsibilities') {
    return Boolean(editing.onToggleRoleRowHidden || editing.onToggleRoleGroupHidden);
  }
  if (kind === 'signature') return Boolean(editing.onToggleSignatureFieldHidden);
  if (PROSE_KINDS.has(kind)) return Boolean(editing.onEditProse);
  return false;
}
